import {
  FETCH_SCREENER_FAILURE,
  FETCH_SCREENER_REQUEST,
  FETCH_SCREENER_SUCCESS,
  FETCH_FOOTNOTESLABEL_SUCCESS,
  FETCH_FOOTNOTESLABEL_FAILURE,
  UPDATE_SORT,
  UPDATE_DISTRIBUTIONS_PERIOD,
  UPDATE_SEARCHED_HOLDINGS,
  UPDATE_PLAN_NUMBER,
  RESET_HOLDINGS_CONTEXT,
  FETCH_DISCLOSURES_BULK_REQUEST,
  FETCH_DISCLOSURES_BULK_SUCCESS,
  FETCH_DISCLOSURES_BULK_FAILURE
} from '../../actions/action-types';
import { FIELDS } from '../../../../shared/screener-constants';
import {
  isSignatureResult,
  getScreenerAsOfDate,
  alignSortingKey,
  alignTiaaFixedAnnuityKey,
  sortStringOrNumber,
  isTiaaFixedAnnuity,
  checkIfHasClassA,
  sortByFieldToTop
} from '../../../../utils/sharedHelpers';
import { addOwnedFundsFlag } from '../helpers/add-owned-funds-flag';
import {
  getFootnotesDisclaimers,
  getDistributionsDisclaimers
} from '../../../../utils/disclaimers-helpers';
import addAllTags from '../../../../utils/result-tags';


const initialState = {
  footnotesLabel: '',
  loading: false,
  mStarRatingDate: '',
  footnoteDisclaimers: {
    numberedDisclaimers: {}
  },
  distributionInputs: {
    distPeriod: 'fye',
    distributionDisclaimers: [],
    distributionDates: {}
  },
  screenerData: [{}],
  signatureResults: [{}],
  error: '',
  totalResults: 0,
  ownedResultsCount: 0,
  planHoldingsList: [],
  channel: '',
  isSearchedPlanInContext: false,
  disclosureBulkNotes: [],
  bluetagcharacteristic: ''
};

// https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers#writing-reducers

// Use the initialState as a default value
const screenerReducer = (state = initialState, action) => {
  // The reducer normally looks at the action type field to decide what happens
  switch (action.type) {
    case FETCH_FOOTNOTESLABEL_SUCCESS: {
      return {
        ...state,
        footnotesLabel: action.payload
      };
    }
    case FETCH_FOOTNOTESLABEL_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }
    case FETCH_SCREENER_REQUEST:
      return {
        ...state,
        disclosureBulkNotes: [],
        loading: true
      };

    case FETCH_SCREENER_SUCCESS: {
      const participantPlansAndTickers = [...action.participantPlansAndTickers];
      const searchedPlanNumber = action.searchedPlanNumber;
      const subPlanNumber = action.subPlanNumber;
      const dataWithTags = addAllTags(action.payload);
      const { data, ownedResultsCount } = addOwnedFundsFlag(participantPlansAndTickers, dataWithTags, action.channel, searchedPlanNumber, subPlanNumber, action.bluetagcharacteristic);
      const signatureResults = getTopThreeFixedAnnuities(data);
      const footnoteDisclaimers = getFootnotesDisclaimers(data, state.footnotesLabel);
      const hasClassA = checkIfHasClassA(data);
      const mStarRatingDate = getScreenerAsOfDate(
        data,
        FIELDS.TCMSTARRATINGASOFDATE
      );
      const performanceMonthlyDate = getScreenerAsOfDate(
        data,
        FIELDS.TCAVGANNRETURNASOFDATE
      );
      const performanceQTRDate = getScreenerAsOfDate(
        data,
        FIELDS.TCAVGANNRETURNQTRASOFDATE
      );
      const performanceAvgAnnReturnMonthlyDate = getScreenerAsOfDate(
        data,
        FIELDS.TCAVGANNRETURNASOFDATE
      );
      const performanceAvgAnnReturnQTRDate = getScreenerAsOfDate(
        data,
        FIELDS.TCAVGANNRETURNQTRASOFDATE
      );
      const performanceRateReturnMonthlyDate = getScreenerAsOfDate(
        data,
        FIELDS.TCRATERETURNASOFDATE
      );
      const performanceRateReturnQTRDate = getScreenerAsOfDate(
        data,
        FIELDS.TCRATERETURNQTRASOFDATE
      );


      return {
        ...state,
        hasClassA,
        loading: false,
        mStarRatingDate,
        performanceMonthlyDate,
        performanceQTRDate,
        performanceAvgAnnReturnMonthlyDate,
        performanceAvgAnnReturnQTRDate,
        performanceRateReturnMonthlyDate,
        performanceRateReturnQTRDate,
        screenerData: data,
        signatureResults,
        footnoteDisclaimers,
        error: '',
        totalResults: action.pagination.totalItems,
        ownedResultsCount
      };
    }

    case UPDATE_DISTRIBUTIONS_PERIOD: {
      const distPeriod = action.distPeriod;
      const distributionDates = action.distributionDates;
      const distributionDisclaimers = getDistributionsDisclaimers({ ...distributionDates, distPeriod });
      return {
        ...state,
        distributionInputs: {
          ...state.distributionInputs,
          distPeriod: action.distPeriod,
          distributionDisclaimers,
          distributionDates
        }
      };
    }

    case FETCH_SCREENER_FAILURE:
      return {
        ...state,
        loading: false,
        screenerData: {},
        totalResults: 0,
        error: action.payload
      };
    case UPDATE_SORT: {
      const showSalesCharge = action.showSalesCharge;
      const tempScreenData = [...state.screenerData];
      const tempSignatureResults = [...state.signatureResults];
      const key = alignSortingKey(action.sortBy, action.performanceQuarterly);
      const TiaaFixedAnnuityKey = alignTiaaFixedAnnuityKey(action.sortBy, action.performanceQuarterly);
      if (tempScreenData && tempScreenData.length > 0) {
        tempScreenData.sort((a, b) => {
          return sortStringOrNumber(
            a[isTiaaFixedAnnuity(a.TCFundType) ? TiaaFixedAnnuityKey : key],
            b[isTiaaFixedAnnuity(b.TCFundType) ? TiaaFixedAnnuityKey : key],
            action.sortDirection
          );
        });
      }
      if (tempSignatureResults && tempSignatureResults.length > 0) {
        tempSignatureResults.sort((a, b) =>
          sortStringOrNumber(a[TiaaFixedAnnuityKey], b[TiaaFixedAnnuityKey], action.sortDirection)
        );
      }
      if (showSalesCharge) {
        sortByFieldToTop(tempScreenData, FIELDS.TCSHARECLASS, 'Class A');
      }
      return {
        ...state,
        screenerData: tempScreenData,
        signatureResults: tempSignatureResults
      };
    }
    case UPDATE_PLAN_NUMBER: {
      return {
        ...state,
        channel: action.channel
      };
    }
    case UPDATE_SEARCHED_HOLDINGS: {
      return {
        ...state,
        planHoldingsList: action.payload,
        isSearchedPlanInContext: true
      };
    }
    case RESET_HOLDINGS_CONTEXT: {
      return {
        ...state,
        isSearchedPlanInContext: false
      };
    }
    case FETCH_DISCLOSURES_BULK_REQUEST:
      return {
        ...state,
        loading: true
      };

    case FETCH_DISCLOSURES_BULK_SUCCESS: {
      return {
        ...state,
        loading: false,
        disclosureBulkNotes: action.payload
      };
    }
    case FETCH_DISCLOSURES_BULK_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }
    default:
      return state;
  }
};

function getTopThreeFixedAnnuities(data) {
  const fixedAnnuityFunds = data?.filter(fund =>
    isSignatureResult(fund.TCFundType)
  );
  const sorted = fixedAnnuityFunds.sort(
    (a, b) => b[FIELDS.TCRATERETURNQTR3YR] - a[FIELDS.TCRATERETURNQTR3YR]
  );
  return sorted.slice(0, 3);
}
export default screenerReducer;
